import React from "react";
import { AdminTemplate } from "../../components";
import { SalesmanBonusesTable } from "../../components/organisms/salesman/SalesmanBonusesTable";

export const SalesmanBonusesPage = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Satış Primleri",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
            showHeaderTitle={true}
        >
            <SalesmanBonusesTable />
        </AdminTemplate>
    );
};
